import { Id } from "@dgs/core";

export const vacationKeys = {
	all: ["vacations"] as const,
	lists: () => [...vacationKeys.all, "lists"] as const,
	ownLists: () => [...vacationKeys.all, "lists", "own"] as const,
	details: () => [...vacationKeys.all, "detail"] as const,
	detail: (id: Id) => [...vacationKeys.details(), `${id}`],
};
